
/* eslint-disable */
import postsQuery from '~/apollo/queries/posts'

export default {
  layout: 'journalPages',
  data () {
    return {
      resultCount: 0,
      showFilters: false,
      posts: [],
      loading: 0
    }
  },
  head () {
    return {
      title: this.metaTitle,
      link: [
        {
          rel: 'canonical',
          href: 'https://studio375.it' + this.path
        }
      ],
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDesc
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: 'https://studio375.it/media/logo-studio375.png'
        },
        {
          hid: 'og:image:width',
          property: 'og:image:width',
          content: '1200'
        },
        {
          hid: 'og:image:height',
          property: 'og:image:height',
          content: '630'
        },
        {
          hid: 'og:image:type',
          property: 'og:image:type',
          content: 'image/png'
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.metaTitle
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://studio375.it' + this.path
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDesc
        },
        {
          hid: 'og:locale',
          property: 'og:locale',
          content: 'it_IT'
        },
        {
          hid: 'og:site_name',
          property: 'og:site_name',
          content: 'Studio375'
        }
      ],
      bodyAttrs: {
        class: 'journal'
      }
    }
  },
  async asyncData ({ $graphql }) {
    const data = await $graphql.default.request(postsQuery)
    return {
      data: data.posts.edges
    }
  },
  computed: {
    path () {
      if (this.$route.path.charAt(this.$route.path.length - 1) === '/') {
        return this.$route.path
      } else {
        return this.$route.path + '/'
      }
    },
    content () {
      const pageInfo = this.$store.getters.getPageByID(400)[0]
      return (pageInfo.content !== null) ? pageInfo.content : null
    },
    currentPage () {
      return 1
    },
    itemsPerPage () {
      return this.$store.state.itemsPerPage
    },
    totalPages () {
      if (this.resultCount === 0) {
        return 1
      } else {
        return Math.ceil(this.resultCount / this.itemsPerPage)
      }
    },
    paginate () {
      if (!this.data || this.data.length != this.data.length) {
        return
      }
      this.resultCount = this.data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = this.totalPages
      }
      var queryFirstPost = this.data[0].node.slug
      this.$store.commit('setFirstPost', queryFirstPost)
      const index = this.currentPage * this.itemsPerPage - this.itemsPerPage
      return this.data.slice(index, index + this.itemsPerPage)
    },
    prev () {
      return this.currentPage - 1
    },
    next () {
      return this.currentPage + 1
    },
    metaDesc () {
      return this.$store.getters.getSeoByID(400).metaDesc
    },
    metaTitle () {
      return this.$store.getters.getSeoByID(400).title
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setBackProjectsPath', from.path)
    next()
  },
  methods: {
    isVisible (num) {
      let ret = false
      const current = parseInt(this.currentPage)
      if((num <= current + 3 && num >= current) || (num >= current - 3 && num <= current) || (current == 1 && num <= 7) || (current == 2 && num <= 7) || (current == 3 && num <= 7) || (current == this.totalPages & num >= this.totalPages - 6) || (current == this.totalPages-1 & num >= this.totalPages - 6) || (current == this.totalPages-2 & num >= this.totalPages - 6))
        return true

      return (num === current) ? true : ret
    },
     closeSidebar (event) {
      const button = document.querySelector('.open_filters')
      if(event.target !== button)
        this.showFilters = false
    },
    includeFunction () {
      return document.querySelector('.open_filters')
    },
    setNextPost (next){
        const url = '/progetti/'+next.slug
        this.$store.commit('setNextPost', url)
    }
  }
}
